import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=647334c4&scoped=true"
import script from "./LayoutHeader.vue?vue&type=script&lang=ts"
export * from "./LayoutHeader.vue?vue&type=script&lang=ts"
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&id=647334c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647334c4",
  null
  
)

export default component.exports